import React, { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import { Search, Library } from "lucide-react";
import api from "@/lib/api";
import { Input } from "@/components/ui/input";
import { NewsRow, QuietEmpty, useOpenContent, TYPE_LABEL } from "./agentParts";

const TABS = [["", "Everything"], ["leadership", "Leadership"], ["announcement,article", "News"], ["recognition", "Recognition"], ["resource", "Resources & documents"]];

export default function ContentLibrary() {
  const [sp, setSp] = useSearchParams();
  const preview = sp.get("preview") === "agent";
  const type = sp.get("type") || "";
  const open = useOpenContent(preview);
  const [q, setQ] = useState("");
  const [cat, setCat] = useState("");
  const [data, setData] = useState(null);
  useEffect(() => {
    const t = setTimeout(() => {
      api.get("/content/library", { params: { type, q, category: cat, preview: preview ? "agent" : "" } })
        .then((r) => setData(r.data)).catch(() => setData({ items: [], categories: [] }));
    }, 200);
    return () => clearTimeout(t);
  }, [type, q, cat, preview]);
  const setType = (t) => { const n = new URLSearchParams(sp); if (t) n.set("type", t); else n.delete("type"); setSp(n); setCat(""); };
  const groups = {};
  (data?.items || []).forEach((i) => { const k = (i.published_on || "").slice(0, 7); (groups[k] = groups[k] || []).push(i); });
  return (
    <div className="max-w-4xl mx-auto" data-testid="content-library">
      <p className="text-[11px] font-semibold uppercase tracking-[0.2em] text-slate-400">Agent Home</p>
      <h1 className="font-editorial text-3xl sm:text-4xl text-slate-900 mt-1">The Archive</h1>
      <p className="text-slate-500 mt-2">Every message, memo, newsletter and document published for you.</p>
      <div className="mt-6 flex flex-col gap-3">
        <div className="relative"><Search className="w-4 h-4 text-slate-400 absolute left-3 top-1/2 -translate-y-1/2" />
          <Input value={q} onChange={(e) => setQ(e.target.value)} placeholder="Search titles, topics and authors" className="pl-9 bg-white" data-testid="library-search" /></div>
        <div className="flex gap-2 overflow-x-auto pb-1">
          {TABS.map(([k, l]) => <button key={k || "all"} onClick={() => setType(k)} data-testid={`library-tab-${k || "all"}`}
            className={`shrink-0 rounded-full px-3.5 py-1.5 text-sm font-medium border transition-colors ${type === k ? "bg-slate-900 text-white border-slate-900" : "bg-white text-slate-600 border-slate-200 hover:border-slate-300"}`}>{l}</button>)}
        </div>
        {data?.categories?.length > 0 && (
          <div className="flex gap-1.5 flex-wrap">{data.categories.map((c) => <button key={c} onClick={() => setCat(cat === c ? "" : c)} data-testid={`library-cat-${c}`}
            className={`rounded-md px-2 py-0.5 text-xs border ${cat === c ? "bg-brand text-white border-brand" : "text-slate-500 border-slate-200 bg-white"}`}>{c}</button>)}</div>
        )}
      </div>
      <div className="mt-8">
        {data === null ? <div className="h-40 rounded-xl bg-slate-100 animate-pulse" /> : data.items.length === 0 ? (
          <QuietEmpty icon={Library} text={q || cat ? "Nothing matches that search." : `No ${type ? TYPE_LABEL[type.split(",")[0]]?.toLowerCase() : ""} items have been published yet.`} testId="library-empty" />
        ) : Object.entries(groups).map(([month, items]) => (
          <section key={month} className="mb-8">
            <h2 className="text-xs font-semibold uppercase tracking-wider text-slate-400 border-b border-slate-200 pb-2">
              {month ? new Date(`${month}-15T12:00:00`).toLocaleDateString(undefined, { month: "long", year: "numeric" }) : "Undated"}</h2>
            {items.map((i) => <NewsRow key={i.id} item={i} open={open} />)}
          </section>
        ))}
      </div>
    </div>
  );
}
